import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { persistStore } from 'redux-persist';
import { Persistor } from 'redux-persist/es/types';
import { RootState, store } from 'src/store/store';
import { logout } from 'src/store/slices/authSlice';
import { SIGNIN } from './constants';
import { api } from './axiosInstance';

const AuthVerify = () => {
  //single hooks starts here
  const dispatch = useDispatch()
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  let abortController = new AbortController();
  //single hooks ends here


  //useSelectors starts here
  const { user, admin }: any = useSelector((state: RootState) => state.auth)
  //useSelectors ends here


  //functions starts here
  const logOut = (message = '') => {
    const toastMsg = (message !== '') ? message : t('toastMessage.authVarification');
    toast.error(toastMsg, { position: 'top-right', autoClose: 2500 });
    // Clear the persisted state
    const persistor: Persistor = persistStore(store);
    persistor.purge();
    setTimeout(() => {
      dispatch(logout());
      navigate((SIGNIN));
    }, 1500);
  };
  //functions ends here

  api.interceptors.request.use(
    (req: any) => {
      const token = store.getState().auth.admin?.token
      if (token) {
        req.headers.Authorization = 'Bearer ' + token;
      }
      req.signal = abortController.signal;
      return req;
    },
    (err: any) => {
      if (err?.response?.status === 401) {
        store.dispatch(logout())
      } else {
        return Promise.reject(err);
      }
    }
  );

  api.interceptors.response.use(
    (res: any) => {
      return res;
    },
    (err: any) => {
      if (err?.response?.status === 401) {
        toast.error(err?.response?.data?.message || "Session Timeout. Please login again");
        store.dispatch(logout())
        // Abort all ongoing requests
        abortController.abort();
        abortController = new AbortController();
        return Promise.reject(err);
      } else if (err?.response?.status === 402) {
        toast.error(err?.response?.data?.message || "Please contact your administrator");
        store.dispatch(logout())
        abortController.abort();
        abortController = new AbortController();
        return Promise.reject(err);
      }
      else if (err?.response?.status === 403
      ) {
        store.dispatch(logout())
        return Promise.reject(err?.response);
      } else {
        return Promise.reject(err);
      }
    }
  );

  //For Parsing JWT
  const parseJwt = (token: any) => {
    try {
      return JSON.parse(atob(token.split(".")[1]));
    } catch (e) {
      return null;
    }
  };

  //useEffects starts here
  useEffect(() => {
    if (user || admin) {
      const decodedJwt = parseJwt(user ? user?.token : admin?.token);
      if (decodedJwt.exp * 1000 < Date.now()) {
        logOut();
      }
    }
  }, []);
  //useEffects ends here
  return (<></>)
}
export default AuthVerify;